import { NetworkStatus, WatchQueryFetchPolicy } from "@apollo/client";
import { useMemo } from "react";

import { PollingIntervalGroups } from "apollo/constants";
import usePolledQuery from "apollo/usePolledQuery";
import { SearchInput } from "types/generated";

import { SEARCH_OPEN_TOFU_MIGRATE_STACKS } from "./gql";

type UseOpenTofuMigrationSearchStacksProps = {
  variables: { input: SearchInput };
  pollingGroup: PollingIntervalGroups;
  nextFetchPolicy?: WatchQueryFetchPolicy;
};

const useOpenTofuMigrationSearchStacks = ({
  variables,
  pollingGroup,
  nextFetchPolicy,
}: UseOpenTofuMigrationSearchStacksProps) => {
  const { data, previousData, loading, error, refetch, networkStatus } = usePolledQuery(
    SEARCH_OPEN_TOFU_MIGRATE_STACKS,
    { variables, pollingGroup, nextFetchPolicy }
  );

  const search = data?.openTofuMigrateSearch || previousData?.openTofuMigrateSearch;

  const entities = useMemo(() => search?.edges.map((edge) => edge.node) || [], [search?.edges]);

  return {
    entities,
    hasData: !!data,
    endCursor: data?.openTofuMigrateSearch?.pageInfo.endCursor,
    startCursor: data?.openTofuMigrateSearch?.pageInfo.startCursor,
    error,
    refetch,
    loadingContent:
      loading &&
      (networkStatus === NetworkStatus.loading || networkStatus === NetworkStatus.setVariables),
    isLoading: (loading && !search) || networkStatus === NetworkStatus.refetch,
  };
};

export default useOpenTofuMigrationSearchStacks;
